export enum ShoppingCartStep {
  CART = 0,
  PAYMENT = 1,
  CONFIRMATION = 2
}
